import { Component, OnInit, EventEmitter, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import {DateAdapter} from '@angular/material/core';
import {TranslateService} from 'ng2-translate/ng2-translate';
import { GeneralService } from '../../services/general.service';
import { ProvidersService } from '../../services/providers.service';
import * as decode from 'jwt-decode';

const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';

@Component({
  selector: 'app-credit-note',
  templateUrl: './credit-note.component.html',
  styleUrls: ['./credit-note.component.scss']
})
export class CreditNoteComponent implements OnInit {
  type: any;
  info: any = {};
  dataXml: any;
  loadBtn = false;
  userToken: any;
  userId: any;
  foreign = false;
  dataForeign: any = {};
  private base64textString: String = '';
  base64Pdf: string;
  filesArr = [];
  filesCountUpload = 0;
  showDrop = true;
  step = 0;
  msgResp: any;
  uploadError = false;
  multipleCC = false;
  sendInfo: any = {};
  listSocieties = [];
  dataOriginalConcepts = [];
  //costosInput:any = [];

  uploader: FileUploader = new FileUploader({
    url: URL,
    isHTML5: true
  });

  hasBaseDropZoneOver = false;

  constructor(public dialog: MatDialog, private toastr: ToastrService, private gralService: GeneralService, private provService: ProvidersService, public translate: TranslateService, private adapter: DateAdapter<any>) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;

    gralService.changeTextHead('SEARCHNOTES');

    translate.onLangChange.subscribe(lang => {
      if(lang.lang == 'en'){
        this.adapter.setLocale('en-GB');
      }

      if(lang.lang == 'es'){
        this.adapter.setLocale('es-MX');
      }
    });

    this.getSocieties();
  }

  ngOnInit() {
    //this.initFilter();
  }
  /*initFilter() {
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
      startWith(''),
      map(value => this._filter(value))
      );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    console.log('filterValue: ', filterValue);
    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders() {
    this.provService.getProvidersNum(this.userToken, this.sendInfo.Sociedad).then((res: any) => {
      this.initFilter();
      this.providersList = res.Entidades;
    });
  }

  addProveedorSearch(option) {
    //console.log('option', option);
    let proveedor = option.split(' - ');
    this.sendInfo.NumProveedor = proveedor[0];
    this.myControl.setValue(proveedor[0]);
  }*/

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.sendInfo.Sociedad = this.listSocieties[0].NoSociedad;
          this.selectSociety();
        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(){
    const society = this.listSocieties.find(x => x.NoSociedad == this.sendInfo.Sociedad);
    if(society.NumProveedor){
      this.sendInfo.NumProveedor = society.NumProveedor;
    }
  }

  disabledProv(){
    let resp = false;
    if(this.sendInfo.Sociedad){
      const society = this.listSocieties.find(x => x.NoSociedad == this.sendInfo.Sociedad);
      if(society.NumProveedor){
        resp = true;
      }
    }
    return resp;
  }

  upp(evt){
    const file = evt.dataTransfer ? evt.dataTransfer.files[0] : evt.target.files[0];
    this.fileUpload(file);
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  dropped(e){
    for(let g = 0; g < e.length; g++){
      this.fileUpload(e[g]);
    }
  }

  fileUpload(file){
    const exist = this.filesArr.find(x => x.name == file.name);
    if(exist){
      this.toastr.error('El archivo ' + file.name + ' ya esta en la lista.', 'Error al crargar archivo');
      return false;
    }

    const pattern = /image-*/;
    const patternPdf = /pdf/;
    const patternXml = /xml/;

    if(this.filesCountUpload < 2){
      if (!file.type.match(patternPdf)) {
        if (!file.type.match(patternXml)) {
          this.toastr.error('El archivo ' + file.name + ' tiene formato de archivo inválido, solo se acepta pdf y xml', 'Error al crargar archivo');
          return false;
        }else{
          this.filesArr.push({file: file, name: file.name, size: file.size, color: 'green', type: 'xml', date: '11-07-2018', error: null, id: 13, url: null});
        }
      }else{
        this.filesArr.push({file: file, name: file.name, size: file.size, color: 'green', type: 'pdf', date: null, error: null, id: null, url: 'http://concent.com.mx'});
      }

      this.filesCountUpload++;
      if(this.filesCountUpload >= 2){
        this.showDrop = false;
      }
    }
  }

  _loadxml(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    this.info.xmlBase64 = btoa(binaryString);
  }


  _loadPdf(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64Pdf = btoa(binaryString);
    this.info.pdfBase64 = btoa(binaryString);
  }

  deleteFile(idx){
    this.filesArr.splice(idx, 1);
    this.filesCountUpload--;
    if(this.filesCountUpload < 2){
      this.showDrop = true;
    }
  }

  upload(){
    if(this.filesArr.length == 0){
      this.toastr.error('Favor de agregar la factura', 'Error al crargar archivo');
      return false;
    }

    this.loadBtn = true;
    let existXml = false;
    let existPdf = false;

    for(let g = 0; g < this.filesArr.length; g++){
      console.log(this.filesArr[g]);
      if(this.filesArr[g].type == 'xml'){
        const reader = new FileReader();
        reader.onload = this._loadxml.bind(this);
        reader.readAsBinaryString(this.filesArr[g].file);
        existXml = true;
      }

      if(this.filesArr[g].type == 'pdf'){
        const reader = new FileReader();
        reader.onload = this._loadPdf.bind(this);
        reader.readAsBinaryString(this.filesArr[g].file);
        existPdf = true;
      }
    }
    this.loadBtn = false;
    console.log("exist foreign", this.foreign);
    console.log("exist XML", existXml);
    console.log("exist PDF", existPdf);
    
    setTimeout(() => {
      this.loadBtn = false;


      if(this.foreign){
        if(!existPdf){
          this.loadBtn = false;
          this.toastr.error('Favor de agregar el archivo PDF', 'Cargar nota de crédito');
          return false;
        }
        
        if(!this.dataForeign.cuenta_mayor || !this.dataForeign.numero || !this.dataForeign.society || !this.dataForeign.nombre || !this.dataForeign.moneda || !this.dataForeign.subTotal || !this.dataForeign.total || !this.dataForeign.fecha || !this.dataForeign.centro_costos){
          this.toastr.error('Favor de agregar los datos obligatorios', 'Cargar nota de crédito');
          return false;
        }

       

        const params = {
          Pdf: this.info.pdfBase64, CuentaDeMayor: this.dataForeign.cuenta_mayor,
          CentroCostos: this.dataForeign.centro_costos,
          NumProveedor: this.dataForeign.numero,
          Sociedad: this.dataForeign.society,
          InfExtranjerosNT: { NombreProveedor: this.dataForeign.nombre, Moneda: this.dataForeign.moneda, SubTotal: this.dataForeign.subTotal, Total: this.dataForeign.total, Fecha: this.dataForeign.fecha }
        }

        this.provService.addCreditNote(params, this.userToken).then((data) => {
          if(data['operacion']){
            let msgs = '';
            for(let g = 0; g < data['listaMensajes'].length; g++){
              msgs = msgs+'<br>- '+data['listaMensajes'][g];
            }
            this.toastr.success(msgs, 'Cargar nota de crédito');
            this.step = 2;
          }else{
            let msgs = '';
            for(let g = 0; g < data['listaMensajes'].length; g++){
              msgs = msgs+'<br>- '+data['listaMensajes'][g];
            }
            this.toastr.error(msgs, 'Cargar nota de crédito');
            return;
          }
        }, (err) => {
          console.log(err);
          this.toastr.error(JSON.stringify(err), 'Cargar nota de crédito');
          return;
        });
      }else{
        if(!existPdf){
          this.loadBtn = false;
          this.toastr.error('Favor de agregar el archivo PDF', 'Cargar nota de crédito');
          return false;
        }
        if(!existXml){
          this.loadBtn = false;
          this.toastr.error('Favor de agregar el archivo XML', 'Cargar nota de crédito');
          return false;
        }

        if (!this.sendInfo.Sociedad) {
          this.loadBtn = false;
          this.toastr.error('Favor de seleccionar la sociedad', 'Cargar nota de crédito');
          return false;
        }

        /*this.toastr.success('Archivo correcto', 'Cargar nota de crédito');
        this.step = 1;*/

        this.provService.uploadCreditNote({
          xmlB64: this.info.xmlBase64,
          Sociedad: this.sendInfo.Sociedad
        }, this.userToken).then((data) => {
          this.loadBtn = false;
          if(data['operacion']){
            //this.toastr.success('Archivo correcto', 'Cargar archivo');
           
            this.dataXml = data['informacionXml'];
            this.dataXml = data['informacionXml'];
            let fechaXML = this.dataXml['fechaCFDI'];
            let currentYear = new Date().getFullYear();
            let CFDIAnio = fechaXML.split("-");
            if(CFDIAnio[0] < currentYear){
              this.loadBtn = false;
              this.toastr.error('Solo se permiten notas de crédito del año en curso, fecha emision '+fechaXML, 'Cargar archivo');
              return false;
            }
            this.step = 1;
            this.getConcepts(this.dataXml.informacionConceptos);

          }else{
            this.toastr.error(data['mensaje'], 'Cargar archivo');
            return;
          }
        }, (err) => {
          console.log(err);
          this.loadBtn = false;
          this.toastr.error('Error al cargar archivo', 'Cargar archivo');
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }

    }, 1000);
  }

  reset(){
    this.step = 0;
    this.filesArr = [];
    this.filesCountUpload = 0;
    this.showDrop = true;
    this.sendInfo = {};
  }

  send(){
    if(!this.sendInfo.NumProveedor || !this.sendInfo.Sociedad){
      this.toastr.error('Favor de agregar los datos obligatorios', 'Cargar nota de crédito');
      return false;
    }

    if (!this.multipleCC && !this.sendInfo.CuentaDeMayor) {
      this.toastr.error('Favor de agregar los datos obligatorios', 'Cargar nota de crédito');
      return false;
    }

    var listaCCFinal = [];
    if (this.multipleCC) {

      var index = -1;
      var listaConcepto = [];
      var listaCC = [];

      var principal = null;

      this.sendInfo.Xml = this.info.xmlBase64;
      this.sendInfo.Pdf = this.info.pdfBase64;
      this.sendInfo.IdUsuario = this.userId
      //this.sendInfo.CentrosCostosConceptos = this.costosInput;
      this.sendInfo.CentrosCostosConceptos = listaCC;
      this.sendInfo.informacionImpuestos = this.dataXml.informacionImpuestos;

      this.dataXml.informacionConceptos.forEach(function (concepto) {

        if (concepto.index != index && index != -1 && principal != null && listaConcepto.length == 0) {
          //el principal se agrega como parte de la sublista cuando no tiene mas elementos divididos
          listaConcepto.push({
            Descripcion: principal.descripcion,
            ClaveProdServ: principal.claveProdServ,
            CuentaContable: principal.CuentaContable,
            CentroCostos: principal.CentroCostos,
            Importe: principal.importe,
            TextoPosicion: principal.TextoPosicion
          });
        }

        if (concepto.index != index && index != -1 && listaConcepto.length > 0) {
          listaCC.push({
            Descripcion: principal.descripcion,
            ClaveProdServ: principal.claveProdServ,
            Importe: principal.importe,
            Conceptos: listaConcepto
          });
          listaConcepto = [];
          principal = null;
        }

        if (concepto.principal) {
          principal = concepto;
        }

        if (!concepto.principal && concepto.index == index) {
          listaConcepto.push({
            Descripcion: concepto.descripcion,
            ClaveProdServ: concepto.claveProdServ,
            CuentaContable: concepto.CuentaContable,
            CentroCostos: concepto.CentroCostos,
            Importe: concepto.importe,
            TextoPosicion: concepto.TextoPosicion
          });
        }

        index = concepto.index;
        //if (concepto.costosInput.CuentaContable != '' || concepto.costosInput.CentroCostos != '') {
        //}
      });

      if (principal != null && listaConcepto.length == 0) {
        listaConcepto.push({
          Descripcion: principal.descripcion,
          ClaveProdServ: principal.claveProdServ,
          CuentaContable: principal.CuentaContable,
          CentroCostos: principal.CentroCostos,
          Importe: principal.importe,
          TextoPosicion: principal.TextoPosicion
        });
      }

      if (index != -1 && listaConcepto.length > 0) {
        //listaCC.push(listaConcepto);
        listaCC.push({
          Descripcion: principal.descripcion,
          ClaveProdServ: principal.claveProdServ,
          Importe: principal.importe,
          Conceptos: listaConcepto
        });
        listaConcepto = [];
      }

      //console.log("listaCC %o ", listaCC);
      var isValidImporte = true;
      var toastrCopy = this.toastr;
      listaCC.forEach(function (concepto) {
        //console.log("concepto %o ", concepto);

        var sumConcepto = concepto.Conceptos.reduce(function (acc, val) { return acc + val.Importe; }, 0);
        if (isNaN(sumConcepto))
          sumConcepto = 0;
        if (sumConcepto != concepto.Importe) {
          toastrCopy.error('Concepto: ' + concepto.ClaveProdServ + " - " + concepto.Descripcion + ", La suma de los SubImporte: " + sumConcepto + " no es igual al importe del Concepto original: " + concepto.Importe, 'Cargar factura manual',
            { disableTimeOut: true });
          //timeOut = false;
          isValidImporte = false;
        }
      });

      if (!isValidImporte)
        return false;

      listaCC.forEach(function (concepto) {
        listaCCFinal.push(concepto.Conceptos);
      });
    }

    this.sendInfo.Xml = this.info.xmlBase64;
    this.sendInfo.Pdf = this.info.pdfBase64;
    this.sendInfo.IdUsuario = this.userId
    this.sendInfo.CentrosCostosConceptos = listaCCFinal;
    this.sendInfo.informacionImpuestos = this.dataXml.informacionImpuestos;


    this.provService.addCreditNote(this.sendInfo, this.userToken).then((data) => {
      if(data['operacion']){
        this.toastr.success('Se cargo correctamente la nota de crédito', 'Cargar nota de crédito');
        this.reset();
      }else{
        let msgs = '';
        for(let g = 0; g < data['listaMensajes'].length; g++){
          msgs = msgs+'<br>- '+data['listaMensajes'][g];
        }
        this.toastr.error(msgs, 'Cargar nota de crédito', { disableTimeOut: true } );
        return;
      }
    }, (err) => {
      console.log(err);
      this.toastr.error(JSON.stringify(err), 'Cargar nota de crédito', { disableTimeOut: true });
      return;
    });
  }

  addLineCC(rowIndex, row) {
    console.log(row);
    var target = this.iterationCopy(row);
    console.log(target);
    this.dataXml.informacionConceptos.splice(rowIndex + 1, 0, target);
    console.log(this.dataXml.informacionConceptos);
  }

  removeLineCC(rowIndex) {
    this.dataXml.informacionConceptos.splice(rowIndex, 1);
    console.log(this.dataXml.informacionConceptos);
  }

  iterationCopy(src) {
    var target = {};
    for (let prop in src) {
      if (src.hasOwnProperty(prop)) {
        target[prop] = src[prop];
      }
    }
    target['principal'] = false;
    return target;
  }

  uploadMultipesCC() {

    if (this.multipleCC) {
      this.dataXml.informacionConceptos = JSON.parse(JSON.stringify(this.dataOriginalConcepts));
      console.log(" this.dataOriginalConcepts %o ", this.dataOriginalConcepts);
    } else {
      this.sendInfo.CuentaDeMayor = null;
      this.sendInfo.CentroCostos = null;
      this.sendInfo.TextoPosiciones = null;
    }
  }

  getConcepts(data) {

    let conceptosTemp = data;
    var idRow = 0;
    if (conceptosTemp.length > 0) {
      conceptosTemp.forEach(function (concepto) {
        concepto.index = idRow++;
        concepto.principal = true;
        concepto.CentroCostos = '';
        concepto.CuentaContable = '';
        concepto.TextoPosicion = '';
        //concepto.costosInput = [];
        //concepto.costosInput.push({ CentroCostos: '', CuentaContable: '' });
      });
    }

    this.dataOriginalConcepts = JSON.parse(JSON.stringify(conceptosTemp));
  }

}
